// components/ResponsiveImage.tsx
import React, { useState, useRef, useEffect, CSSProperties } from 'react';

interface ResponsiveImageProps {
  imagePath: string;
  alt: string;
  style?: CSSProperties;
}

const ResponsiveImage: React.FC<ResponsiveImageProps> = ({
  imagePath,
  alt,
  style,
}) => {
  const base = imagePath.replace(/\.[^/.]+$/, '');
  const [loaded, setLoaded] = useState(false);
  const imgRef = useRef<HTMLImageElement>(null);

  // handle already-cached images that fire onLoad before mount
  useEffect(() => {
    if (imgRef.current?.complete) {
      setLoaded(true);
    }
  }, []);

  const srcSet = `
    ${base}_320.webp 320w,
    ${base}_480.webp 480w,
    ${base}_768.webp 768w,
    ${base}_1024.webp 1024w
  `;

  const sizes = `
    (max-width: 768px) calc(100vw - 2rem),
    20vw
  `;

  return (
    <div
      className="blur-wrap"
      style={{ backgroundImage: `url(${base}_30.webp)` }}
    >
      <img
        ref={imgRef}
        src={`${base}_320.webp`}
        alt={alt}
        srcSet={srcSet}
        sizes={sizes}
        loading="lazy"
        decoding="async"
        onLoad={() => setLoaded(true)}
        className={loaded ? 'img-loaded' : ''}
        style={style}
      />
    </div>
  );
};

export default ResponsiveImage;
